import { render, staticRenderFns } from "./InicisFailedComponent.vue?vue&type=template&id=2fa31aa4&"
import script from "./InicisFailedComponent.vue?vue&type=script&lang=js&"
export * from "./InicisFailedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports